module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dfffae66f4a57806d99b490b385319bc.gif";